import { styled } from '@mui/material';

import { Icon } from '»components/atoms';

export const OuterContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 0,
  marginTop: 10,
  backgroundColor: theme.palette.colors.primaryBackground,

  [theme.breakpoints.down('lg')]: {
    marginBottom: 127,
  },
}));

export const InnerContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'column',
    width: '328px',
    [theme.breakpoints.up('md')]: {
      width: '439px',
    },
  },
  margin: `0 ${theme.spacing(2)} ${theme.spacing()}`,
}));

export const IconStyled = styled(Icon)(() => ({
  width: 'auto',
  height: '46px',
  alignSelf: 'flex-start',
}));
